import React from "react";

import NameHeader from "../shared/NameHeader";
import Summary from "../shared/Summary";

import * as CONSTANTS from "../../utilities/Constants";
import { IInstrumentViewData } from "../../models/instrument/InstrumentViewData";

import { Translation } from "react-i18next";

import "../../utilities/Extensions";
import { IDeviceViewData } from "../../models/device/DeviceViewData";
import IColumnHeaderData from "../../models/shared/ColumnHeaderData";
import AbbTableComponent from "../shared/AbbTableComponent";
import History from "../../utilities/History";
import utility from "../shared/Utility";
import renderBreadcrumb from "../../utilities/Breadcrumb";

interface ILandingProps {
  instrumentData: IInstrumentViewData;
  deviceData: IDeviceViewData;
}

interface IState {
  list: any;
}

export default class Landing extends React.Component<ILandingProps, IState> {
  private _mount: boolean = false;
  private _columns: IColumnHeaderData[];

  constructor(props: ILandingProps) {
    super(props);
    this._mount = true;
    this.state = {
      list: this.props.instrumentData.properties,
    };
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if (this.props != prevProps) {
      let listData = this.props.instrumentData.properties
      listData?.map((item: any, index: any, array: any) => {
        item.selectedDirection = [];
        array.map((i: any) => {
          if (i.id === item.id) {
            item.selectedDirection.push(i.direction.name)
          }
        })
        item.selectedDirection = item.selectedDirection.filter((x: any, index: any) => {
          return item.selectedDirection.indexOf(x) === index
        })
        item.selectedDirection = item.selectedDirection.toString();
      })
      listData = utility.removeDuplicatefromArrayBasedOnId(listData)
      this.setState({
        list: listData,
      });
    }
  }

  private onChangeValue = (e: any, rowIndex: number, colIndex: number) => {
    const name = e.target.name;
    let list = [...this.state.list];
    let item = list[rowIndex];

    if (name.indexOf(".") !== -1) {
      const data = e.target.name.split(".");
      var result: any = item;
      for (let index = 0; index < data.length - 1; index++) {
        result = result[data[index]];
      }
      result[data[data.length - 1]] = e.target.value;
    } else {
      item[e.target.name] = e.target.value;
    }
    list[rowIndex] = item;
    this.setState({
      list,
    });
  };

  private onStartInstrumentTest = () => {
    History.push({
      pathname: CONSTANTS.INSTRUMENT_MEASUREMENT_OVERVIEW,
      state: this.props.instrumentData.id,
    });
  };
  public breadcrumpClick = (link: string): void => {
    if (link) History.push(link);
  };

  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="page-layout">
            {renderBreadcrumb(
              [
                { text: t("Home"), link: "/samplenew", bolder: false },
                { text: t(CONSTANTS.MENU_CONFIG), link: null, bolder: false },
                { text: t(CONSTANTS.SUBMENU_INSTRUMENT), link: null, bolder: true }
              ], "pl-3 pb-3")
            }
            <NameHeader
              authKey={CONSTANTS.AUTHKEY_INSTRUMENT}
              data={this.props.instrumentData.name}
              startInstrumentTest={true}
              onStartInstrumentTest={this.onStartInstrumentTest}
              isEnable={this.props.instrumentData.isEnabled}
              isEnabeDisableButton={true}
            />
            <div className="summary-layout">
              <Summary>
                <div className="page-scroll">
                  <div className="row mt-3">
                    <div className="col-md-3">
                      <span className="summary-label">
                        {t(CONSTANTS.LABLE_INSTRUMENT_CODE)}:
                      </span>
                      <span className="summary-value ml-2">
                        {this.props.instrumentData.codeId}
                      </span>
                    </div>
                    <div className="col-md-4">
                      <span className="summary-label">
                        {" "}
                        {t(CONSTANTS.LABLE_INSTRUMENT_TYPE)}:{" "}
                      </span>
                      <span className="summary-value ml-2">
                        {this.props.instrumentData.type.name}
                      </span>
                    </div>

                    <div className="col-md-3">
                      <span className="summary-label">
                        {t(CONSTANTS.LABLE_INSTRUMENT_STATE)}:{" "}
                      </span>
                      <span className="summary-value ml-2">
                        {this.props.instrumentData.state}
                      </span>
                    </div>

                    {this.props.deviceData.connectionType === "Ftp" ? (
                      <div className="col-md-2">
                        <span className="summary-label">
                          {t(CONSTANTS.LABLE_INSTRUMENT_PORT)} :{" "}
                        </span>
                        <span className="summary-value ml-2">
                          {this.props.deviceData.port}
                        </span>
                      </div>
                    ) : null}

                    {this.props.deviceData.ipAddress ? (
                      <div className="col-3 mt-3">
                        <span className="summary-label">
                          {t(CONSTANTS.LABLE_INSTRUMENT_IP)}:
                        </span>
                        <span className="summary-value ml-2">
                          {this.props.deviceData.ipAddress}
                        </span>
                      </div>
                    ) : null}
                    <div
                      className={
                        this.props.deviceData.connectionType === "Ftp"
                          ? "col-4 mt-3"
                          : "col-3 mt-3"
                      }
                    >
                      <span className="summary-label">
                        {t(CONSTANTS.CONNECTION_TYPE)}:
                      </span>
                      <span className="summary-value ml-2">
                        {this.props.deviceData.connectionType}
                      </span>
                    </div>
                    {this.props?.instrumentData?.instrumentStation ? (
                      <div className="col-4 mt-3" style={{ display:'flex' }}>
                        <span className="summary-label" style={{ width:'155px' }}>
                          {t(CONSTANTS.LABLE_INSTRUMENT_STATION)} :{" "}
                        </span>
                        <span className="summary-value ml-2 name-overflow">
                          {this.props?.instrumentData?.instrumentStation?.name}
                        </span>
                      </div>
                    ) : null}

                    <div className={"col-4 mt-3"}>
                      <span className="summary-label">
                        {t("Connection Status")}:
                      </span>

                      <span className="summary-value ml-2" style={{ color: this.props.deviceData.isConnected ? 'green' : 'red' }}>
                        {this.props.deviceData.isConnected
                          ? t("Connected")
                          : t("Not Connected")}
                      </span>
                    </div>
                  </div>
                </div>
              </Summary>
            </div>
            <div className="summary-layout">
              <AbbTableComponent
                authKey={CONSTANTS.AUTHKEY_INSTRUMENT}
                columns={[
                  {
                    dataField: "name",
                    text: t(CONSTANTS.MODULE_PROPERTY),
                    isFixed: true,
                  },
                  {
                    dataField: "customId",
                    text: t(CONSTANTS.LABEL_PROPERTYID),
                    isFixed: false,
                  },
                  {
                    dataField: "selectedDirection",
                    text: t(CONSTANTS.LABEL_CAPS_DIRECTION),
                    isFixed: false,
                  },
                  {
                    dataField: "unit",
                    text: t(CONSTANTS.LABEL_UNIT),
                    isFixed: false,
                  },
                  {
                    dataField: "min",
                    text: t(CONSTANTS.LABLE_MIN + " " + CONSTANTS.LABEL_VALUE),
                    isFixed: false,
                  },
                  {
                    dataField: "max",
                    text: t(CONSTANTS.LABLE_MAX + " " + CONSTANTS.LABEL_VALUE),
                    isFixed: false,
                  },
                  {
                    dataField: "decimals",
                    text: t(CONSTANTS.LABEL_DECIMALS),
                    isFixed: false,
                  },
                ]}
                list={this.state.list}
                select={false}
                isFixedColumn={true}
                isEditable={false}
                isTitle={
                  <div>
                    <p className="sidebar-main-title font-weight-bold">
                      {t(CONSTANTS.LABEL_PROPERTIES)}
                    </p>
                  </div>
                }
              />
            </div>
          </div>
        )}
      </Translation>
    );
  }
}
